module.exports = __webpack_public_path__ + "img/icon-select-empty.75f4dd78.png";